import {Inject, Injectable} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {HttpClient, HttpResponse} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {DOCUMENT} from "@angular/common";
import {Uuid} from "../interface/response/uuid";
import {first, map, take} from "rxjs/operators";
import {ChronieJobListTypes, ChroniePaymentListTypes} from "../interface/chronie";
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ChronieService {

  public readonly chroniePaymentListSubject: ReplaySubject<CountedAndPaginated<ChroniePaymentListTypes>>
    = new ReplaySubject<CountedAndPaginated<ChroniePaymentListTypes>>(1);
  public readonly chronieJobListSubject: ReplaySubject<CountedAndPaginated<ChronieJobListTypes>>
    = new ReplaySubject<CountedAndPaginated<ChronieJobListTypes>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  public issuePolicy(paymentId: string, selectedDate: string): Observable<any> {
    return this.httpClient
      .post<any>(`/rest/crm/api/chronie/insurance-policies/${paymentId}/${selectedDate}/issue`, null)
      .pipe(first());
  }

  public sendPolicy(paymentId: string): Observable<any> {
    return this.httpClient
      .post<any>(`/rest/crm/api/chronie/insurance-policies/${paymentId}/send`, null)
      .pipe(first());
  }

  public getPaymentLst(
    page: number,
    pageSize: number,
    filters: object,
    sort?: { sortBy?: string, sortOrder?: string},
  ): void {
    // eslint-disable-next-line max-len
    this.httpClient.get(`/rest/crm/api/chronie/payment?page=${page + 1}&pageSize=${pageSize}&sortBy=${sort.sortBy ?? ''}&sortOrder=${sort.sortOrder ?? ''}&`
      + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<ChroniePaymentListTypes>) => {
        this.chroniePaymentListSubject.next(result);
      });
  }


  public downloadReport(filters: object,  sort?: { sortBy?: string, sortOrder?: string}): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/api/chronie/payment/report?&sortBy=${sort.sortBy ?? ''}&sortOrder=${sort.sortOrder ?? ''}&`
      + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }


  downloadFile(filePathOrId: string, suggestedName?: string): Observable<void> {
    const url = `${environment.chronieUrl}file/public${filePathOrId}`;
    return this.httpClient.get(url, {
      responseType: 'blob',
      observe: 'response',
      // withCredentials: true, // włącz, jeśli serwer wymaga ciasteczek/sesji
    }).pipe(
      map((res: HttpResponse<Blob>) => {
        const blob = res.body!;
        // nazwa z Content-Disposition (jeśli serwer ją podaje)
        const cd = res.headers.get('content-disposition') || '';
        const m = /filename\*?=(?:UTF-8''|")?([^\";]*)/i.exec(cd);
        const headerName = m ? decodeURIComponent(m[1]) : undefined;

        const fileName =
          suggestedName || headerName || this.fallbackNameFromUrl(url) || 'plik';

        const a = document.createElement('a');
        const objectUrl = URL.createObjectURL(blob);
        a.href = objectUrl;
        a.download = fileName;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(objectUrl);
      })
    );
  }

  public getJobLst(
    page: number,
    pageSize: number,
    filters: object,
    sort?: { sortBy?: string, sortOrder?: string},
  ): void {
    // eslint-disable-next-line max-len
    this.httpClient.get(`/rest/crm/api/chronie/job?page=${page + 1}&pageSize=${pageSize}&sortBy=${sort.sortBy ?? ''}&sortOrder=${sort.sortOrder ?? ''}&`
      + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<ChronieJobListTypes>) => {
        this.chronieJobListSubject.next(result);
      });
  }


  private fallbackNameFromUrl(u: string): string | undefined {
    try {
      const p = new URL(u, window.location.href).pathname;
      const last = p.split('/').filter(Boolean).pop();
      return last || undefined;
    } catch { return undefined; }
  }

}
